import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spring, animated } from 'react-spring';


import TrainingText from 'components/TrainingContent/TrainingText';
import TrainingVideo from 'components/TrainingContent/TrainingVideo';

export default class RetainContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: this.props.image,
      showContent: false,
      index: 0,
    };

    this.toggleContent = this.toggleContent.bind(this);
  }

  componentDidUpdate() {
    const { image } = this.state;
    if (image !== this.props.image) {
      this.updateContent(this.props.image);
    }
  }

  updateContent(image) {
    this.setState({ image });
    this.setState({ showContent: false });
  }

  toggleContent() {
    this.setState((prevState) => ({
      showContent: !prevState.showContent,
    }));
    this.setState(({ index }) => ({ index: index === 2 ? 0 : index + 1 }));
  }

  render() {
    const { image, showContent, index } = this.state;

    const { appId, params, summary, buttons } = this.props;

    return (
      <div className="retain__container">
        {params.pageType === '' && (
          <Spring
            native
            keys={index}
            from={{ opacity: 0 }}
            to={{
              opacity: showContent ? 0 : 1,
              transform: showContent ? 'scale(0)' : 'scale(1)',
              display: showContent ? 'none' : 'flex',
            }}
          >
            {(styles) => (
              <animated.div className="retain__textWrapper" style={styles}>
                <div className="retain__summary">
                  <h3>{summary.title}</h3>
                  <div>{summary.text}</div>
                  <div className="retain__summary--butons">{buttons}</div>
                  <button className="readMoreBtn" onClick={this.toggleContent}>
                    {i18n.translate('trainingScreens.watchListenRead')}
                    <FontAwesomeIcon icon={['fas', 'caret-down']} />
                  </button>
                </div>
                <div className="retain__banner">
                  <img src={image} alt={image} />
                  {params.imageCredits && <h3>{params.imageCredits}</h3>}
                </div>
              </animated.div>
            )}
          </Spring>
        )}
        {params.pageType === '' && (
          <Spring
            native
            keys={index}
            to={{
              opacity: showContent ? 1 : 0,
              top: showContent ? 0 : 100,
              display: showContent ? 'block' : 'none',
            }}
          >
            {(styles) => (
              <animated.div className="retain__text" style={styles}>
                <div className="retain__linkButtons">{buttons}</div>
                <button className="btnInverse closeBtn" onClick={this.toggleContent}>
                  <FontAwesomeIcon icon={['fas', 'window-close']} />
                </button>
                <TrainingText
                  key={index}
                  pageID={params.pageID}
                  buttons={null}
                  appId={Number(appId)}
                  {...params}
                  // hideTitle
                />
              </animated.div>
            )}
          </Spring>
        )}
        {params.pageType === 'Photo' && (
          <div className="retain__photo">
            <img src={image} alt={image} />
          </div>
        )}
        {params.pageType === 'autoPlay' && (
          <div className="retain__video">
            <TrainingVideo appId={appId} {...params} />
          </div>
        )}
      </div>
    );
  }
}

RetainContent.propTypes = {
  appId: PropTypes.number.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  summary: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.shape()]),
  }),
  image: PropTypes.string,
  params: PropTypes.shape().isRequired,
};

RetainContent.defaultProps = {
  buttons: [],
  image: PropTypes.string.isRequired,
  summary: {
    title: '',
    text: [],
  },
};
